<template>
    <!-- PROGRESS BAR -->
    <v-card v-if="mode==='runtime'"
            class="align-self-center ml-3 cursor-help"
            flat
            min-width="150"
            max-width="250">

        <v-progress-linear :color="feasibilityRunning ? 'grey' : getProgressColor(item)"
                           height="25"
                           rounded
                           :indeterminate="feasibilityRunning"
                           :value="item.enabled ? getProgressPercent(item) : ''">

            <template v-slot:default="{ value }">
                <strong v-if="!item.disabled && !feasibilityRunning">
                    {{ getProgressPercent(item) }}%
                </strong>
                <strong v-if="item.disabled">DISABLED</strong>
            </template>

        </v-progress-linear>

    </v-card>

</template>

<script>

export default {

    props: {

        item: {
            type: Object,
            required: true,
        },

        mode: {
            type: String,
            required: true,
            validator: value => ['create', 'runtime'].includes(value)
        },

        feasibilityRunning: {
            type: Boolean,
            required: true,
            default: false,
        },

        showAnalyzeResults: {
            type: Boolean,
            required: true,
            default: false,
        }
    },

    data() {
        return {
            colors: [

                {color: "#d32f2f", percent: 10},
                {color: "#ca451b", percent: 20},
                {color: "#be5700", percent: 30},
                {color: "#af6500", percent: 40},
                {color: "#a07100", percent: 50},
                {color: "#907c00", percent: 60},
                {color: "#7f8401", percent: 70},
                {color: "#6e8c1f", percent: 80},
                {color: "#5c9235", percent: 90},
                {color: "#48974b", percent: 10000},
            ]
        }
    },
    
    methods: {

        getProgressPercent(item) {
            if (isNaN(parseInt(item.quota))) return 0;
            if (item.quota === 0) return 0;
            return Math.round(item.count / item.quota * 100 * 100) / 100;
        },

        getProgressColor(item) {

            if (isNaN(parseInt(item.quota))) return 'red';

            if (!item.enabled) return "grey lighten-1";

            const percent = Math.round(item.count / item.quota * 100);

            return this.colors.find(color => percent < color.percent).color;
        },
    }
}
</script>
